// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3hRyA","large":"styles_large__3Bicq"};